import React, { useState } from "react";
import FAQ from "interface/FAQ";
import styles from "styles/components/FAQItem.module.sass";
import ReusableIcon from "./ReusableIcon";

interface FAQItemProps {
    key: number;
    faq: FAQ;
}

/**
 * FAQItem component displays a single FAQ item with a question and answer.
 *
 * @param {number} key - The unique key for the FAQ item.
 * @param {FAQ} faq - The FAQ object containing the question and answer.
 * @returns {JSX.Element} The rendered FAQItem component.
 *
 * @example
 * <FAQItem key={1} faq={{ question: "What is FAQ?", answer: "Frequently Asked Questions" }} />
 */
const FAQItem: React.FC<FAQItemProps> = ({ key, faq }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    }

    return (
        <div key={key} className={styles['faq-item']} onClick={toggleOpen}>
            <p className={styles['faq-question-wrapper']}>
                <div className={styles['faq-left']}>
                    <p className={styles['faq-question']}>{faq.question}</p>
                </div>
                <div className={styles['faq-right']}>
                    <ReusableIcon icon={ isOpen ? 'tabler:chevron-up' : 'tabler:chevron-down'} className={styles['faq-icon'] || 'faq-icon'} color="#111111" />
                </div>
            </p>
            {isOpen && (
                <div className={styles['faq-answer-wrapper']}>
                    <span className={styles['faq-answer']}>{faq.answer}</span>
                </div>
            )}
        </div>
  );
};

export default FAQItem;